module.exports = __webpack_public_path__ + "static/img/b_3.b3a37550.png";